import { render } from "./UserModuleGroupManager.vue?vue&type=template&id=1bd61669"
import script from "./UserModuleGroupManager.vue?vue&type=script&lang=js"
export * from "./UserModuleGroupManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__